module.exports = __webpack_public_path__ + "img/download-o.c0cb52f9.svg";